import { AuthService } from '@okta/okta-react'
import { OktaConfig } from './index'
import jwtDecode from 'jwt-decode'
import moment from 'moment'
import { logger, halfStory as hs } from '../lib/logging'
import { HALF_STORY, logout } from '../lib'

const auth = new AuthService(OktaConfig.auth)
const REFRESH_FREQUENCY_IN_MIN = 20
const EXPIRY_LIMIT_IN_HOURS = 2

export const startRefreshTimer = async () => {
  const idToken = await auth.getIdToken()
  if (!idToken) return

  const decoded = jwtDecode(idToken)
  const expiry = decoded.exp
  const m = moment.unix(expiry)
  console.info('[User:%s] Auth token expires %s at %s (exp %d)', decoded.userID, m.fromNow(), m.format(), expiry)
  logger.info(`[User:${decoded.userID}] Auth token expires ${m.fromNow()} at ${m.format()} (exp ${expiry})}`)

  // If token has expired for more than 2 hours, log the user out/redirect them to the login page
  if (expiredForMoreThanTwoHours(decoded)) {
    console.info('[User:%s] Auth token expired and too old to refresh, logging out immediately', decoded.userID)
    logger.info(`[User:${decoded.userID}] Auth token expired and too old to refresh, logging out immediately`)
    hs.add(HALF_STORY.LOGOUT, 'Logging out - expired token too old to refresh')
    hs.save()
    logout()
    return
  }

  // If the token is close to expiring, refresh it immediately
  if (closeToExpiring(decoded)) {
    // Refresh immediately
    console.info('[User:%s] Auth token expiry already below threshold, refreshing token immediately', decoded.userID)
    logger.info(`[User:${decoded.userID}] Auth token expiry already below threshold, refreshing token immediately`)
    refreshToken()
  }

  // Refresh the token automatically regularly
  console.info('[User:%s] Starting timer to trigger refresh token in %d min at around %s (exp %d)', decoded.userID, REFRESH_FREQUENCY_IN_MIN, moment().add(REFRESH_FREQUENCY_IN_MIN, 'minutes').format(), expiry)
  logger.info(`[User:${decoded.userID}] Starting timer to trigger refresh token in ${REFRESH_FREQUENCY_IN_MIN} min at around ${moment().add(REFRESH_FREQUENCY_IN_MIN, 'minutes').format()} (exp ${expiry})`)
  return setInterval(refreshToken, REFRESH_FREQUENCY_IN_MIN * 60 * 1000)
}

const refreshToken = () => {
  auth._oktaAuth.tokenManager.renew('idToken')
    .then(newToken => {
      const decoded = jwtDecode(newToken.idToken)
      const m = moment.unix(decoded.exp)
      console.info('[User:%s] Refreshed auth token, new token expires %s at %s (exp %d)', decoded.userID, m.fromNow(), m.format(), decoded.exp)
      logger.info(`[User:${decoded.userID}] Refreshed auth token, new token expires ${m.fromNow()} at ${m.format()} (exp ${decoded.exp})`)

      // Piggybanking on the refresh token logic and save half story
      hs.save()
    })
}

const closeToExpiring = decoded => {
  return moment.unix(decoded.exp).diff(moment(), 'minutes') <= REFRESH_FREQUENCY_IN_MIN
}

const expiredForMoreThanTwoHours = decoded => {
  return moment().diff(moment.unix(decoded.exp), 'hours') >= EXPIRY_LIMIT_IN_HOURS
}

export default auth
